(function(){
  var LOTS = {
    p1:{id:"p1", nom:"Stabyl S2 — une unité",    n:1, prix:24.90},
    p2:{id:"p2", nom:"Stabyl S2 — deux unités",  n:2, prix:49.80},
    p3:{id:"p3", nom:"Stabyl S2 — trois unités", n:3, prix:74.70}
  };
  /* coloris repris du modèle retenu : sangle noire, motif de points coloré */
  var COLS = {
    Gris:{nom:"Gris", hex:"#C9CED4"},
    bleu:  {nom:"Bleu",   hex:"#2F7BE0"},
    rose:  {nom:"Rose",   hex:"#E5408A"}
  };
  var COL_ORDER = ["Gris","bleu","rose"];
  var VARIANT_IDS = {
    bleu: 63735547232586,
    Gris: 63735547199818,
    rose: 63735547330890
  };
  var CART_KEY = "stabyl-cart-shopify-v1", REFS_KEY = "stabyl-cart-refs-v1", ORDER_KEY = "stabyl-order-v2";
  var app = document.getElementById("app"), ccount = document.getElementById("ccount");

  function readLS(k){ try{ return JSON.parse(localStorage.getItem(k)||"null"); }catch(e){ return null; } }
  function writeLS(k,v){ try{ localStorage.setItem(k, JSON.stringify(v)); }catch(e){} }

  var cart = readLS(CART_KEY) || {};
  var cartRefs = readLS(REFS_KEY) || {};
  function saveCart(){ writeLS(CART_KEY, cart); writeLS(REFS_KEY, cartRefs); paintCount(); }
  /* une ligne de panier = un lot + une couleur par genouillère, clé "p2|Gris,rose" */
  function parseKey(k){
    var p = String(k).split("|"), lot = LOTS[p[0]];
    if(!lot) return null;
    var cols = (p[1]||"").split(",").filter(function(c){ return COLS[c]; });
    while(cols.length < lot.n) cols.push("Gris");
    return {lot:lot, cols:cols.slice(0, lot.n)};
  }
  function items(){ var o=[]; for(var k in cart){ var pk=parseKey(k); if(cart[k]>0 && pk) o.push({key:k, lot:pk.lot, cols:pk.cols, q:cart[k]}); } return o; }
  function colNames(cols){ return cols.map(function(c){ return COLS[c].nom; }).join(" · "); }
  function chips(cols){
    return '<span class="chips">'+cols.map(function(c){ return '<span class="chip"><i style="--sw:'+COLS[c].hex+'"></i>'+COLS[c].nom+'</span>'; }).join("")+'</span>';
  }
  function units(){ return items().reduce(function(s,l){ return s + l.lot.n*l.q; },0); }
  function total(){ return items().reduce(function(s,l){ return s + l.lot.prix*l.q; },0); }
  function eur(n){ return n.toFixed(2).replace(".",",") + " €"; }
  function paintCount(){ ccount.textContent = units(); }

  function jsonRequest(url, options){
    options = options || {};
    options.credentials = "same-origin";
    options.headers = Object.assign({"Content-Type":"application/json", "Accept":"application/json"}, options.headers || {});
    return fetch(url, options).then(function(response){
      return response.json().catch(function(){ return {}; }).then(function(data){
        if(!response.ok) throw new Error(data.description || data.message || "Le panier Shopify est momentanément indisponible.");
        return data;
      });
    });
  }
  function packRef(){ return "stabyl-"+Date.now().toString(36)+"-"+Math.random().toString(36).slice(2,9); }
  function setBusy(button, busy, label){
    if(!button) return;
    if(busy){ button.dataset.originalLabel = button.textContent; button.disabled = true; button.textContent = label || "Ajout en cours…"; }
    else { button.disabled = false; button.textContent = button.dataset.originalLabel || button.textContent; }
  }
  function cartError(error){
    var message = (error && error.message) ? error.message : "Impossible de modifier le panier. Réessayez dans un instant.";
    var msg = document.getElementById("cartmsg");
    if(msg){ msg.textContent = message; msg.style.color = "#B4342B"; }
    else window.alert(message);
  }
  function addPackToShopify(key){
    if(units() > 0) return Promise.reject(new Error("Une offre STABYL est déjà dans votre panier. Retirez-la avant d’en choisir une autre."));
    var pack = parseKey(key), ref = packRef();
    if(!pack) return Promise.reject(new Error("Cette offre n’est pas disponible."));
    var addItems = pack.cols.map(function(color, index){
      return {
        id: VARIANT_IDS[color],
        quantity: 1,
        properties: {
          "_stabyl_pack_ref": ref,
          "_stabyl_offer": pack.lot.id,
          "_stabyl_slot": String(index + 1)
        }
      };
    });
    return jsonRequest("/cart/add.js", {method:"POST", body:JSON.stringify({items:addItems})}).then(function(){
      cart[key] = (cart[key] || 0) + 1;
      (cartRefs[key] || (cartRefs[key] = [])).push(ref);
      saveCart();
    });
  }
  function removePackFromShopify(key, removeAll){
    var refs = (cartRefs[key] || []).slice();
    var targetRefs = removeAll ? refs : refs.slice(-1);
    if(!targetRefs.length){
      if(removeAll || (cart[key] || 0) <= 1){ delete cart[key]; delete cartRefs[key]; }
      else cart[key]--;
      saveCart();
      return Promise.resolve();
    }
    return jsonRequest("/cart.js").then(function(shopifyCart){
      var updates = {};
      (shopifyCart.items || []).forEach(function(line){
        var ref = line.properties && line.properties._stabyl_pack_ref;
        if(targetRefs.indexOf(ref) !== -1) updates[line.key] = 0;
      });
      if(!Object.keys(updates).length) return null;
      return jsonRequest("/cart/update.js", {method:"POST", body:JSON.stringify({updates:updates})});
    }).then(function(){
      if(removeAll || (cart[key] || 0) <= 1){ delete cart[key]; delete cartRefs[key]; }
      else { cart[key]--; cartRefs[key].pop(); }
      saveCart();
    });
  }

  /* ---------- fragments réutilisés ---------- */
  function schema(){
    return '<svg viewBox="0 0 580 560" role="img" aria-label="Schéma technique coté de la sangle Stabyl S2 positionnée sous la rotule">'+
    '<defs>'+
    '<marker id="ar" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="7" markerHeight="7" orient="auto"><path d="M0,1 L9,5 L0,9 z" fill="#1E4FD1"></path></marker>'+
    '<marker id="ar2" viewBox="0 0 10 10" refX="1" refY="5" markerWidth="7" markerHeight="7" orient="auto"><path d="M10,1 L1,5 L10,9 z" fill="#1E4FD1"></path></marker>'+
    '<pattern id="grid" width="26" height="26" patternUnits="userSpaceOnUse"><path d="M26 0 L0 0 0 26" fill="none" stroke="#EDF0F4" stroke-width="1"></path></pattern>'+
    '</defs>'+
    '<rect x="0" y="0" width="580" height="560" fill="url(#grid)"></rect>'+
    '<path d="M196 20 C190 120 188 200 190 258 C176 300 178 350 190 392 C200 448 202 500 200 546" fill="none" stroke="#D3DAE2" stroke-width="1.6"></path>'+
    '<path d="M320 20 C324 118 326 196 328 252 C346 292 344 348 328 388 C314 444 312 498 314 546" fill="none" stroke="#D3DAE2" stroke-width="1.6"></path>'+
    '<circle cx="259" cy="258" r="74" fill="none" stroke="#E3E8ED" stroke-width="1.5"></circle>'+
    '<circle cx="259" cy="258" r="47" fill="none" stroke="#0F1418" stroke-width="1.6"></circle>'+
    '<circle cx="259" cy="258" r="3" fill="#0F1418"></circle>'+
    '<path d="M182 356 C220 342 300 342 338 356 L338 392 C300 378 220 378 182 392 Z" fill="#B39C81" fill-opacity=".2" stroke="#B39C81" stroke-width="1.8"></path>'+
    '<path d="M182 374 C220 360 300 360 338 374" fill="none" stroke="#B39C81" stroke-width="1" stroke-dasharray="3 5"></path>'+
    '<rect x="330" y="352" width="26" height="44" rx="3" fill="#FFFFFF" stroke="#B39C81" stroke-width="1.6"></rect>'+
    '<path d="M336 362 L350 362 M336 374 L350 374 M336 386 L350 386" stroke="#B39C81" stroke-width="1.2" fill="none"></path>'+
    '<g><path d="M182 452 L338 452" fill="none" stroke="#1E4FD1" stroke-width="1" marker-start="url(#ar2)" marker-end="url(#ar)"></path>'+
    '<path d="M182 400 L182 462 M338 400 L338 462" fill="none" stroke="#1E4FD1" stroke-width=".8" opacity=".5"></path>'+
    '<text x="260" y="478" fill="#1E4FD1" font-family="DM Mono, monospace" font-size="13" text-anchor="middle" letter-spacing="1">RÉGLABLE</text>'+
    '<text x="260" y="497" fill="#87909B" font-family="DM Mono, monospace" font-size="9.5" text-anchor="middle" letter-spacing="1.6">TOUR DE GENOU</text></g>'+
    '<g><path d="M132 356 L172 356 M132 392 L172 392" fill="none" stroke="#1E4FD1" stroke-width=".8" opacity=".5"></path>'+
    '<path d="M140 356 L140 392" fill="none" stroke="#1E4FD1" stroke-width="1" marker-start="url(#ar2)" marker-end="url(#ar)"></path>'+
    '<text x="124" y="379" fill="#1E4FD1" font-family="DM Mono, monospace" font-size="12" text-anchor="end" letter-spacing="1">SANGLE</text></g>'+
    '<g><path d="M306 258 L404 258" fill="none" stroke="#1E4FD1" stroke-width=".8" opacity=".5"></path>'+
    '<circle cx="306" cy="258" r="3" fill="#1E4FD1"></circle>'+
    '<text x="412" y="255" fill="#4C555F" font-family="DM Mono, monospace" font-size="10" letter-spacing="1.4">ROTULE</text>'+
    '<text x="412" y="271" fill="#87909B" font-family="DM Mono, monospace" font-size="9" letter-spacing="1.2">APPUI SOUS-JACENT</text></g>'+
    '<text x="24" y="540" fill="#B9C2CC" font-family="DM Mono, monospace" font-size="9" letter-spacing="1.8">Stabyl S2 · COUPE SAGITTALE · ÉCH. 1:2</text>'+
    '</svg>';
  }
  function miniBrace(hex){
    hex = hex || COLS.Gris.hex;
    return '<svg viewBox="0 0 60 44" aria-hidden="true">'+
      '<path d="M4 16 C16 9 44 9 56 16 L56 30 C44 23 16 23 4 30 Z" fill="#1F1F23"></path>'+
      '<g fill="'+hex+'"><circle cx="22" cy="19" r="1.7"></circle><circle cx="28" cy="18" r="1.9"></circle><circle cx="34" cy="18" r="1.9"></circle><circle cx="40" cy="19" r="1.7"></circle>'+
      '<circle cx="25" cy="23" r="1.7"></circle><circle cx="31" cy="22.5" r="1.9"></circle><circle cx="37" cy="23" r="1.7"></circle></g>'+
      '<rect x="48" y="13" width="9" height="20" rx="2" fill="#3A3A40"></rect></svg>';
  }
  function faqItems(open, limit){
    var Q = [
      ["Comment je choisis ma taille ?","Il n'y a qu'une seule taille, pour adulte : la sangle se règle autour du genou grâce à sa fermeture. Si votre genou est nettement plus fin ou plus large que la moyenne, écrivez-nous avant de commander. Et dans tous les cas, vous avez 30 jours pour la renvoyer. Le <a href=\"#/tailles\">guide des tailles</a> explique comment mesurer."],
      ["Ça se voit sous un pantalon ?","Sous un pantalon ample, non. La sangle est fine, mais le coussin en silicone forme un léger relief : sous un jean très ajusté ou un legging, on la devine."],
      ["Je peux la porter toute la journée ?","Le tissu tricoté respire, c'est fait pour ça. Cela dit, commencez par deux ou trois heures les premiers jours et augmentez progressivement — c'est valable pour n'importe quel maintien."],
      ["Comment l'entretenir ?","Suivez les indications de l'étiquette cousue sur la sangle. Dans le doute, lavez-la à la main à l'eau tiède, fermeture refermée, et laissez-la sécher à l'air libre : la chaleur du sèche-linge abîme le coussin en silicone."],
      ["Droite ou gauche ?","Les deux. La sangle est symétrique, sans latéralité. C'est aussi pour ça qu'il n'y a qu'une seule référence au catalogue."],
      ["Est-ce un dispositif médical ?","Non. La Stabyl S2 est un accessoire de maintien et de confort destiné à l'activité physique et à la vie quotidienne. Elle n'a pas de finalité médicale et ne remplace pas l'avis d'un professionnel de santé. Si vous avez une douleur persistante, consultez avant de vous équiper."],
      ["Quels sont les délais de livraison ?","Expédition sous 48 heures ouvrées, livraison offerte en France métropolitaine. Vous recevez un numéro de suivi dès le départ du colis."],
      ["Et si elle ne me convient pas ?","Vous avez 30 jours pour nous la renvoyer, portée ou non. Un e-mail suffit : on envoie l'étiquette et le remboursement part à réception du colis."]
    ];
    return (limit ? Q.slice(0,limit) : Q).map(function(q,i){
      return '<details'+(open&&i===0?" open":"")+'><summary>'+q[0]+'</summary><div class="body"><p>'+q[1]+'</p></div></details>';
    }).join("");
  }

  /* ---------- pages ---------- */
  var views = {};

  var SEL = "p2";
  function optRow(id, label, badge){
    var L = LOTS[id];
    return '<button class="opt" type="button" data-opt="'+id+'" role="radio" aria-checked="'+(SEL===id)+'">'+
      '<span class="dot"></span>'+
      '<span><span class="nm">'+label+(badge?'<span class="bdg">'+badge+'</span>':'')+'</span>'+
      '<span class="sub" style="display:block">'+eur(L.prix/L.n)+" l'unité"+'</span></span>'+
      '<span class="pr">'+eur(L.prix)+'</span></button>';
  }
  function selLabel(){
    var L = LOTS[SEL];
    return (L.n===1?"une unité":L.n===2?"deux unités":"trois unités")+" — "+eur(L.prix);
  }

  var PICK = ["Gris","Gris","Gris"];
  function colorInner(){
    var n = LOTS[SEL].n;
    var h = '<p class="boxlab" style="margin:0">'+(n===1 ? 'Quelle couleur ?' : 'Quelle couleur pour chacune ?')+'</p>';
    for(var u=0; u<n; u++){
      h += '<div class="colrow"><span class="cl">'+(n===1 ? 'Couleur' : 'Genouillère '+(u+1))+' : <b>'+COLS[PICK[u]].nom+'</b></span>'+
        '<span class="sws" role="radiogroup" aria-label="'+(n===1 ? 'Couleur' : 'Couleur de la genouillère '+(u+1))+'">'+
        COL_ORDER.map(function(c){
          return '<button type="button" class="sw" role="radio" aria-checked="'+(PICK[u]===c)+'" aria-label="'+COLS[c].nom+'" title="'+COLS[c].nom+'" data-col="'+c+'" data-unit="'+u+'" style="--sw:'+COLS[c].hex+'"></button>';
        }).join("")+'</span></div>';
    }
    return h;
  }

  /* ---------- avis : réservés aux clients ayant commandé ---------- */
  var REV_KEY = "stabyl-reviews-v1";
  function esc(t){ return String(t).replace(/[&<>"']/g, function(c){ return {"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;","'":"&#39;"}[c]; }); }
  function starStr(n){
    var h = ''; for(var i = 1; i <= 5; i++) h += i <= n ? '★' : '<span class="off">★</span>';
    return '<span class="stars" role="img" aria-label="'+n+' sur 5">'+h+'</span>';
  }
  /* aperçu de mise en page : avis FICTIFS, masqués par défaut et marqués comme tels à chaque affichage */
  var RV_DEMO = false;
  var RV_EXAMPLES = [
    {prenom:"Sophie L.",  note:5, coloris:"Rose",          texte:"Je la porte pour courir trois fois par semaine. Elle reste en place, même quand ça monte, et le rose est plus joli qu'en photo."},
    {prenom:"Karim B.",   note:4, coloris:"Bleu",          texte:"Bon maintien sous la rotule. J'enlève une étoile parce que le velcro accroche un peu mes leggings au lavage."},
    {prenom:"Martine D.", note:5, coloris:"Gris",        texte:"J'en ai pris deux pour la randonnée, une par genou. Facile à mettre, et au bout d'une heure on ne la sent presque plus."},
    {prenom:"Thomas R.",  note:3, coloris:"Bleu",          texte:"Correcte pour le prix, mais j'ai le genou assez large et je suis presque au bout du réglage. À vérifier avant de commander si vous êtes costaud."},
    {prenom:"Nadia K.",   note:5, coloris:"Gris · Rose", texte:"Lot de deux en deux couleurs : une pour moi, une pour ma sœur. Colis bien emballé, rien à redire."},
    {prenom:"Julien P.",  note:4, coloris:"Gris",        texte:"Pratique au foot en salle, le coussin en silicone est confortable. Seul regret : pas de pochette pour la ranger dans le sac."},
    {prenom:"Élodie M.",  note:2, coloris:"Rose",          texte:"Jolie, mais elle glisse un peu quand je transpire beaucoup. Le service client m'a proposé le retour sans discuter, c'est déjà ça."},
    {prenom:"Patrick G.", note:4, coloris:"Bleu",          texte:"Je marche beaucoup pour le travail. Elle se fait oublier sous un pantalon large et tient toute la journée."}
  ];
  function reviewsSection(){
    var R = readLS(REV_KEY) || [];
    var demo = !R.length && RV_DEMO;
    var shown = R.length ? R.slice().reverse() : (demo ? RV_EXAMPLES : []);
    var head = '', list;
    if(shown.length){
      var avg = shown.reduce(function(t, r){ return t + r.note; }, 0) / shown.length;
      head = '<div class="rv-score"><b>'+avg.toFixed(1).replace(".", ",")+'</b><div>'+starStr(Math.round(avg))+
        '<div style="font-size:14px;color:var(--muted)">'+(demo ? 'Moyenne de l\'exemple fictif' : R.length+' avis vérifié'+(R.length > 1 ? 's' : ''))+'</div></div></div>';
      list = (demo ? '<div class="rv-demo-banner"><span><strong>Aperçu de mise en page.</strong> Ces avis sont fictifs : ils servent uniquement à visualiser la section et ne doivent jamais être publiés comme de vrais avis.</span><button type="button" class="rm" id="rv-demo">Masquer l\'exemple</button></div>' : '')+
        '<div class="rv-list">'+shown.map(function(r){
          return '<article class="rv"><div class="rv-top"><span class="rv-name">'+esc(r.prenom)+'</span>'+
            (demo ? '<span class="fict">Exemple fictif</span>'
                  : '<span class="rv-date">'+new Date(r.date).toLocaleDateString("fr-FR", {day:"2-digit", month:"short", year:"numeric"})+'</span>')+'</div>'+
            '<div class="rv-meta">'+starStr(r.note)+(demo ? '' : '<span class="verified">Achat vérifié</span>')+(r.coloris ? '<span>Coloris : '+esc(r.coloris)+'</span>' : '')+'</div>'+
            '<p>'+esc(r.texte)+'</p></article>';
        }).join("")+'</div>';
    } else {
      list = '<div class="rv-empty"><strong>Pas encore d\'avis.</strong><br>Les avis publiés ici viennent uniquement de clients ayant commandé. Vous avez reçu votre sangle ? Racontez-nous.'+
        '<br><button type="button" class="btn ghost" id="rv-demo" style="margin-top:18px;padding:12px 20px;font-size:15px">Voir un exemple de mise en page</button></div>';
    }
    var stars = '';
    for(var i = 5; i >= 1; i--){ stars += '<input type="radio" name="rv-note" id="rv-n'+i+'" value="'+i+'"><label for="rv-n'+i+'" title="'+i+' sur 5">★</label>'; }
    return '<section class="sec-tint" id="avis"><div class="wrap">'+
      '<div class="rv-head"><div class="shead" style="margin:0"><h2>Avis clients</h2><p>Uniquement des clients qui ont commandé, publiés sans tri.</p></div>'+head+'</div>'+
      list+
      '<form class="rv-form" id="reviewform" novalidate><h3 style="margin-bottom:16px">Laisser un avis</h3>'+
        '<div class="frow"><div class="field"><label for="rv-ref">Référence de commande</label><input id="rv-ref" placeholder="STB-…" autocomplete="off"></div>'+
        '<div class="field"><label for="rv-prenom">Prénom</label><input id="rv-prenom" autocomplete="given-name" maxlength="40"></div></div>'+
        '<div class="field"><span style="font-size:14px;color:var(--ink-2)">Votre note</span><div class="rate" role="radiogroup" aria-label="Votre note">'+stars+'</div></div>'+
        '<div class="field"><label for="rv-texte">Votre avis</label><textarea id="rv-texte" rows="4" maxlength="800"></textarea></div>'+
        '<button class="btn" type="submit">Publier mon avis</button>'+
        '<p class="rv-msg" id="rv-msg" role="status"></p>'+
        '<p class="rv-policy"><strong>Comment nous vérifions les avis :</strong> seuls les clients ayant passé commande peuvent publier, avec la référence reçue par e-mail. Tous les avis sont publiés, positifs comme négatifs, et aucun n\'est rémunéré.</p>'+
      '</form></div></section>';
  }
  function submitReview(e){
    e.preventDefault();
    var msg = document.getElementById("rv-msg");
    var ref = document.getElementById("rv-ref").value.trim().toUpperCase();
    var prenom = document.getElementById("rv-prenom").value.trim();
    var texte = document.getElementById("rv-texte").value.trim();
    var noteEl = document.querySelector('input[name="rv-note"]:checked');
    var o = readLS(ORDER_KEY);
    function fail(t){ msg.style.color = "#B4342B"; msg.textContent = t; }
    if(!o || !ref || ref !== String(o.ref).toUpperCase()) return fail("Référence introuvable. Seuls les clients ayant commandé peuvent laisser un avis : utilisez la référence reçue par e-mail.");
    if(!prenom || !noteEl || texte.length < 10) return fail("Indiquez votre prénom, une note et quelques mots sur votre expérience.");
    var R = readLS(REV_KEY) || [];
    if(R.some(function(r){ return r.ref === ref; })) return fail("Un avis a déjà été publié pour cette commande.");
    var col = (o.lignes || []).map(function(l){ var m = /\(([^)]+)\)/.exec(l.nom); return m ? m[1] : ""; }).filter(Boolean).join(" · ");
    R.push({ref:ref, prenom:prenom.slice(0, 40), note:+noteEl.value, texte:texte.slice(0, 800), coloris:col, date:new Date().toISOString()});
    writeLS(REV_KEY, R);
    route();
    var sec = document.getElementById("avis"); if(sec) sec.scrollIntoView({block:"start"});
  }

  views["#/"] = function(){
    return '<header class="hero"><div class="wrap"><div class="hero-grid"><div>'+
      '<span class="tag">Sangle de maintien rotulien</span>'+
      '<h1 style="margin:14px 0 0">Le maintien,<br>réduit à l\'essentiel.</h1>'+
      '<p class="lead">Une seule taille pour adulte, qui se règle autour du genou. Tissu tricoté, coussin en silicone et <b>trois coloris au choix</b>.</p>'+
      '<div class="buybox" id="buybox">'+
        '<p class="boxlab">Combien en voulez-vous ?</p>'+'<div class="opts" role="radiogroup" aria-label="Choisir une quantité">'+
          optRow("p1","1 genouillère","")+
          optRow("p2","2 genouillères","Le plus choisi")+
          optRow("p3","3 genouillères","")+
        '</div>'+
        '<div class="colorbox" id="colorbox">'+colorInner()+'</div>'+
        '<button class="btn wide" id="addsel">Ajouter au panier — '+eur(LOTS[SEL].prix)+'</button>'+
        '<p id="cartmsg" role="status" aria-live="polite" style="font-size:14px;margin:12px 0 0"></p>'+
        '<p class="reassure">Livraison offerte · Expédiée sous 48 h · Retour gratuit pendant 30 jours</p>'+
      '</div>'+
      '</div><div><div class="stage3d" id="stage3d"><div class="fallback">'+schema()+'</div>'+'<span class="cot">3 coloris</span><span class="hint">Glissez pour tourner</span></div></div></div>'+
      '<div class="specstrip">'+
        '<div><span class="v">100 %</span><span class="k">Polyester tricoté</span></div>'+
        '<div><span class="v">Silicone</span><span class="k">Coussin amortissant</span></div>'+
        '<div><span class="v">Unique</span><span class="k">Taille adulte réglable</span></div>'+
        '<div><span class="v">3</span><span class="k">Coloris</span></div>'+
      '</div></div></header>'+

    '<section><div class="wrap"><div class="shead"><h2>Pourquoi elle ne bouge pas</h2></div>'+
      '<div class="grid3">'+
      '<article class="card"><div class="rule"></div><h3>Elle reste où on la met</h3><p>Le velcro tient sur toute la longueur. Après deux heures de marche, elle est encore à la même hauteur qu\'au départ.</p></article>'+
      '<article class="card"><div class="rule"></div><h3>Aucune pièce rigide</h3><p>Ni baleine ni plaque dure : un tissu tricoté et un coussin en silicone. Elle accompagne le mouvement du genou au lieu de le bloquer.</p></article>'+
      '<article class="card"><div class="rule"></div><h3>Elle ne chauffe pas</h3><p>Le tissu tricoté laisse passer l\'air. C\'est ce qui fait qu\'on la garde toute la journée.</p></article>'+
      '</div></div></section>'+

    '<section class="sec-tint"><div class="wrap"><div class="shead"><h2>Les informations utiles</h2>'+
      '<p>Une seule référence. Rien à choisir dans une grille de tailles.</p></div>'+
      '<div class="scroll"><table class="spec"><tbody>'+
      '<tr><td>Type</td><td>Sangle rotulienne réglable</td></tr>'+
      '<tr><td>Matière</td><td>Tissu tricoté · 100 % polyester</td></tr>'+
      '<tr><td>Coussin</td><td>Silicone amortissant, placé sous la rotule</td></tr>'+
      '<tr><td>Fermeture</td><td>Sangle réglable avec passant</td></tr>'+
      '<tr><td>Finition</td><td>Bords gansés à maille serrée</td></tr>'+
      '<tr><td>Taille</td><td>Unique · adulte</td></tr>'+
      '<tr><td>Pièce rigide</td><td>Aucune</td></tr>'+
      '<tr><td>Substances préoccupantes</td><td>Aucune déclarée par le fabricant</td></tr>'+
      '<tr><td>Coloris</td><td>Gris · Bleu · Rose</td></tr>'+
      '<tr><td>Fabrication</td><td>Chine</td></tr>'+
      '<tr><td>Livraison</td><td>Offerte · expédiée sous 48 h</td></tr>'+
      '</tbody></table></div>'+
      '<p style="margin-top:18px"><a href="#/tailles">Vérifier qu\'elle vous ira</a></p>'+
      '</div></section>'+

    '<section><div class="wrap"><div class="pledge">'+
      '<svg viewBox="0 0 120 120" width="104" height="104" role="img" aria-label="Engagement trente jours">'+
      '<circle cx="60" cy="60" r="54" fill="none" stroke="#E3E8ED" stroke-width="1.5"></circle>'+
      '<circle cx="60" cy="60" r="42" fill="none" stroke="#B39C81" stroke-width="1.8"></circle>'+
      '<text x="60" y="58" fill="#0F1418" font-family="Epilogue, sans-serif" font-size="30" font-weight="800" text-anchor="middle" letter-spacing="-1">30</text>'+
      '<text x="60" y="78" fill="#87909B" font-family="DM Mono, monospace" font-size="9" text-anchor="middle" letter-spacing="2">JOURS</text></svg>'+
      '<div><h3>Trente jours pour changer d\'avis</h3>'+
      '<p>Portée ou non. Un e-mail suffit : on envoie l\'étiquette de retour et le remboursement part à réception. C\'est plus long que les quatorze jours prévus par la loi, et c\'est volontaire.</p></div>'+
      '</div></div></section>'+

    reviewsSection()+
    '<section><div class="wrap"><div class="shead"><h2>Vos questions</h2></div>'+
      '<div style="max-width:820px">'+faqItems(true,4)+
      '<p style="margin-top:18px"><a href="#/faq">Toutes les questions</a></p></div>'+
      '</div></section>';
  };

  views["#/panier"] = function(){
    var L = items();
    var head = '<div class="wrap pagehead"><h1>Votre panier</h1></div>';
    if(!L.length){
      return head + '<section style="padding-top:28px"><div class="wrap"><div class="empty">'+
        '<h3>Le panier est vide.</h3><p>Rien n\'y est encore. La page produit vous attend.</p>'+
        '<a class="btn" href="#/">Voir la Stabyl S2</a></div></div></section>';
    }
    var lines = L.map(function(it){
      return '<div class="line">'+
        '<div class="thumb">'+miniBrace(COLS[it.cols[0]].hex)+'</div>'+
        '<div><h3>'+it.lot.nom+'</h3><div class="sub">'+it.lot.n+' sangle'+(it.lot.n>1?"s":"")+' · '+eur(it.lot.prix/it.lot.n)+" l'unité"+'</div>'+chips(it.cols)+
        '<button class="rm" data-rm="'+it.key+'">Retirer</button></div>'+
        '<div class="right"><span class="sub">1 offre</span><span class="amt">'+eur(it.lot.prix*it.q)+'</span></div>'+
      '</div>';
    }).join("");

    return head + '<section style="padding-top:28px"><div class="wrap"><div class="cartgrid">'+
      '<div class="lines">'+lines+'</div>'+
      '<aside class="summary"><h3>Récapitulatif</h3>'+
      '<div class="srow"><span>Sous-total</span><b>'+eur(total())+'</b></div>'+
      '<div class="srow"><span>Livraison</span><b class="free">Offerte</b></div>'+
      '<div class="srow total"><span>Total</span><b>'+eur(total())+'</b></div>'+
      '<a class="btn wide" href="/checkout" style="margin-top:20px">Passer la commande</a>'+
      '<p style="font-size:14px;color:var(--muted);margin:16px 0 0;text-align:center">Expédition sous 48 h · 30 jours pour changer d\'avis</p>'+
      '</aside></div></div></section>';
  };

  views["#/commande"] = function(){
    window.location.assign("/checkout");
    return '<div class="wrap pagehead"><h1>Redirection vers le paiement sécurisé…</h1></div>';
  };

  views["#/confirmation"] = function(){
    var o = readLS(ORDER_KEY);
    if(!o) return '<div class="wrap pagehead"><h1>Aucune commande</h1><p>Il n\'y a pas de commande récente à afficher dans ce navigateur.</p></div>'+
      '<section style="padding-top:20px"><div class="wrap"><a class="btn" href="#/">Retour au produit</a></div></section>';
    var lignes = o.lignes.map(function(l){ return '<div class="srow"><span>'+l.nom+' × '+l.q+'</span><b>'+eur(l.montant)+'</b></div>'; }).join("");
    return '<section style="padding-top:56px"><div class="narrow"><div class="conf">'+
      '<svg viewBox="0 0 64 64" width="60" height="60" style="margin:0 auto" role="img" aria-label="Commande validée">'+
      '<circle cx="32" cy="32" r="30" fill="#E4F3EB" stroke="#12764A" stroke-width="1.6"></circle>'+
      '<path d="M20 33 L28 41 L45 24" fill="none" stroke="#12764A" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path></svg>'+
      '<h1 style="font-size:34px;margin-top:20px">Commande enregistrée.</h1>'+
      '<span class="ref">'+o.ref+'</span>'+
      '<p style="color:var(--ink-2);max-width:48ch;margin:0 auto 26px">Un e-mail de confirmation part maintenant. Vous recevrez le numéro de suivi dès que le colis quitte l\'entrepôt, sous 48 heures ouvrées.</p>'+
      '<div style="text-align:left;max-width:420px;margin:0 auto">'+lignes+
      '<div class="srow"><span>Livraison</span><b class="free">Offerte</b></div>'+
      '<div class="srow total"><span>Total</span><b>'+eur(o.total)+'</b></div></div>'+
      '<div style="display:flex;gap:12px;justify-content:center;margin-top:28px;flex-wrap:wrap">'+
      '<a class="btn" href="#/suivi">Suivre ma commande</a><a class="btn ghost" href="#/">Retour au produit</a></div>'+
      '</div></div></section>';
  };

  views["#/suivi"] = function(){
    var o = readLS(ORDER_KEY);
    var body;
    if(o){
      body = '<div class="doc"><h2 style="margin-bottom:6px">Commande '+o.ref+'</h2>'+
        '<p style="font-family:var(--mono);font-size:13px;color:var(--muted);margin-bottom:28px">Passée le '+new Date(o.date).toLocaleDateString("fr-FR",{day:"2-digit",month:"long",year:"numeric"})+'</p>'+
        '<div class="steps">'+
        '<div class="stp done"><span class="dot"></span><div><h4>Commande reçue</h4><p>Le paiement est confirmé et la préparation est lancée.</p><div class="when">Aujourd\'hui</div></div></div>'+
        '<div class="stp now"><span class="dot"></span><div><h4>En préparation</h4><p>Votre colis est en cours d\'emballage dans notre entrepôt.</p><div class="when">Sous 48 h ouvrées</div></div></div>'+
        '<div class="stp"><span class="dot"></span><div><h4>Remis au transporteur</h4><p>Vous recevrez le numéro de suivi par e-mail à cette étape.</p><div class="when">En attente</div></div></div>'+
        '<div class="stp"><span class="dot"></span><div><h4>En cours de livraison</h4><p>Le colis circule sur le réseau de distribution.</p><div class="when">En attente</div></div></div>'+
        '<div class="stp"><span class="dot"></span><div><h4>Livré</h4><p>Les 30 jours pour changer d\'avis démarrent à la réception.</p><div class="when">En attente</div></div></div>'+
        '</div></div>';
    } else {
      body = '<div class="doc"><h2>Retrouver une commande</h2>'+
        '<p>Saisissez la référence reçue par e-mail. Elle commence par <span style="font-family:var(--mono)">STB-</span>.</p>'+
        '<form id="trackform" class="frow" style="margin-top:20px;align-items:end">'+
        '<div class="field" style="margin:0"><label for="t-ref">Référence de commande</label><input id="t-ref" placeholder="STB-20260911-4821"></div>'+
        '<button class="btn" type="submit" style="height:49px">Rechercher</button></form>'+
        '<p id="trackmsg" style="margin:18px 0 0;font-size:15.5px;color:var(--muted)">Aucune commande n\'est enregistrée dans ce navigateur pour le moment.</p></div>';
    }
    return '<div class="wrap pagehead"><h1>Suivi de commande</h1><p>L\'état de votre colis, étape par étape.</p></div>'+
      '<section style="padding-top:28px"><div class="narrow" style="max-width:820px">'+body+'</div></section>';
  };

  views["#/tailles"] = function(){
    return '<div class="wrap pagehead"><h1>Guide des tailles</h1><p>Une seule taille, pour adulte, qui se règle autour du genou. Voici comment vérifier qu\'elle vous ira.</p></div>'+
    '<section style="padding-top:28px"><div class="wrap"><div class="anat">'+
    '<div class="doc" style="padding:32px">'+
      '<svg viewBox="0 0 400 340" role="img" aria-label="Schéma de mesure du tour de genou à mi-rotule">'+
      '<path d="M150 20 C146 90 145 140 146 178 C136 208 137 244 146 272 C152 306 153 320 152 334" fill="none" stroke="#D3DAE2" stroke-width="1.6"></path>'+
      '<path d="M248 20 C251 88 252 136 253 174 C266 204 265 242 253 270 C245 304 244 320 245 334" fill="none" stroke="#D3DAE2" stroke-width="1.6"></path>'+
      '<circle cx="199" cy="176" r="42" fill="none" stroke="#E3E8ED" stroke-width="1.5"></circle>'+
      '<circle cx="199" cy="176" r="27" fill="none" stroke="#0F1418" stroke-width="1.6"></circle>'+
      '<ellipse cx="199" cy="176" rx="56" ry="12" fill="none" stroke="#1E4FD1" stroke-width="2" stroke-dasharray="6 4"></ellipse>'+
      '<path d="M60 176 L138 176" fill="none" stroke="#1E4FD1" stroke-width=".9" opacity=".5"></path>'+
      '<text x="56" y="173" fill="#1E4FD1" font-family="DM Mono, monospace" font-size="11" text-anchor="end" letter-spacing=".6">MI-ROTULE</text>'+
      '<text x="200" y="252" fill="#4C555F" font-family="DM Mono, monospace" font-size="11" text-anchor="middle" letter-spacing="1">MESURER LE TOUR ICI</text>'+
      '<text x="200" y="272" fill="#87909B" font-family="DM Mono, monospace" font-size="9.5" text-anchor="middle" letter-spacing="1.4">JAMBE TENDUE, DEBOUT</text>'+
      '</svg></div>'+
    '<div><div class="doc">'+
      '<h2>La mesure, en trois points</h2>'+
      '<ul><li>Tenez-vous <strong>debout, jambe tendue</strong>, pas assis : le tour de genou change de près de deux centimètres entre les deux positions.</li>'+
      '<li>Passez le mètre ruban <strong>à mi-hauteur de la rotule</strong>, à plat contre la peau, sans serrer.</li>'+
      '<li>Notez la mesure en centimètres. C\'est tout.</li></ul>'+
      '<h2>Ce que ça donne</h2>'+
      '<p>La sangle existe en <strong>taille unique pour adulte</strong> et se règle par sa fermeture. Si votre genou est nettement plus fin ou plus large que la moyenne, envoyez-nous votre mesure avant de commander : nous vous dirons franchement si elle convient.</p>'+
      '<h2>En cas de doute</h2>'+
      '<p>Si vous hésitez, commandez quand même : les trente jours couvrent exactement ce cas. Vous essayez la vraie sangle et vous la renvoyez si elle ne convient pas.</p>'+
      '<p style="margin-bottom:0"><a href="#/contact">Nous écrire avant de commander</a></p>'+
    '</div></div></div></div></section>';
  };

  views["#/faq"] = function(){
    return '<div class="wrap pagehead"><h1>Questions fréquentes</h1><p>Les huit questions qu\'on nous pose vraiment. Si la vôtre n\'y est pas, écrivez-nous.</p></div>'+
      '<section style="padding-top:28px"><div class="narrow" style="max-width:820px">'+faqItems(true)+
      '<div class="note" style="margin-top:24px">Une question qui n\'est pas là ? <a href="#/contact">Écrivez-nous</a>, on répond sous un jour ouvré.</div>'+
      '</div></section>';
  };

  function doc(titre, chapo, corps){
    return '<div class="wrap pagehead"><h1>'+titre+'</h1>'+(chapo?'<p>'+chapo+'</p>':'')+'</div>'+
      '<section style="padding-top:28px"><div class="narrow" style="max-width:820px"><div class="doc">'+corps+'</div></div></section>';
  }
  var TODO = '<span class="todo">À COMPLÉTER</span>';

  views["#/mentions"] = function(){
    return doc("Mentions légales","Identité de l'éditeur, de l'hébergeur et du responsable de publication.",
      '<div class="note" style="margin-bottom:26px"><b>Ces pages sont un gabarit.</b> Les champs marqués '+TODO+' doivent être remplis avec vos informations réelles avant toute mise en ligne. Une boutique publiée sans ces mentions est en infraction dès la première vente.</div>'+
      '<h2>Éditeur du site</h2><ul>'+
      '<li>Dénomination sociale : '+TODO+'</li><li>Forme juridique : '+TODO+'</li>'+
      '<li>Adresse du siège : '+TODO+'</li><li>Numéro SIRET : '+TODO+'</li>'+
      '<li>Numéro de TVA intracommunautaire : '+TODO+' (ou mention « TVA non applicable, article 293 B du CGI »)</li>'+
      '<li>Adresse e-mail : '+TODO+'</li><li>Téléphone : '+TODO+'</li></ul>'+
      '<h2>Directeur de la publication</h2><p>'+TODO+'</p>'+
      '<h2>Hébergeur</h2><p>Shopify International Limited, 2nd Floor Victoria Buildings, 1-2 Haddington Road, Dublin 4, D04 XN32, Irlande.</p>'+
      '<h2>Médiateur de la consommation</h2><p>Conformément à l\'article L612-1 du Code de la consommation, nous adhérons au service de médiation suivant : '+TODO+' — nom, adresse postale et site internet du médiateur.</p>'+
      '<h2>Propriété intellectuelle</h2><p>L\'ensemble des contenus de ce site — textes, schémas techniques, illustrations, mise en page — est protégé. Toute reproduction sans autorisation écrite préalable est interdite.</p>');
  };

  views["#/cgv"] = function(){
    return doc("Conditions générales de vente","Applicables à toute commande passée sur ce site par un consommateur.",
      '<div class="note" style="margin-bottom:26px"><b>Gabarit à faire valider.</b> Ce texte couvre les mentions obligatoires en droit français, mais il doit être relu et complété par vos informations réelles avant publication.</div>'+
      '<h2>Article 1 — Objet</h2><p>Les présentes conditions régissent la vente de la sangle de maintien rotulien Stabyl S2 par '+TODO+' à tout consommateur passant commande sur ce site.</p>'+
      '<h2>Article 2 — Prix</h2><p>Les prix sont indiqués en euros toutes taxes comprises. La livraison est offerte en France métropolitaine. Le prix applicable est celui affiché au moment de la validation de la commande.</p>'+
      '<h2>Article 3 — Commande et paiement</h2><p>La commande est validée après acceptation des présentes conditions et confirmation du paiement. Un e-mail récapitulatif est adressé immédiatement. Les moyens de paiement acceptés sont indiqués au moment du règlement.</p>'+
      '<h2>Article 4 — Livraison</h2><p>Les commandes sont expédiées sous 48 heures ouvrées. Le délai de livraison indicatif est de 2 à 5 jours ouvrés en France métropolitaine. En cas de retard, vous pouvez nous contacter à tout moment ; conformément à l\'article L216-6 du Code de la consommation, vous pouvez résoudre le contrat si la livraison n\'intervient pas dans un délai supplémentaire raisonnable.</p>'+
      '<h2>Article 5 — Droit de rétractation</h2>'+
      '<p>Vous disposez d\'un délai de <strong>quatorze jours à compter de la réception</strong> du produit pour exercer votre droit de rétractation, sans avoir à motiver votre décision (article L221-18 du Code de la consommation).</p>'+
      '<p>Pour l\'exercer, informez-nous de votre décision par une déclaration dénuée d\'ambiguïté, à l\'adresse '+TODO+'. Vous pouvez utiliser le formulaire type ci-dessous, sans obligation.</p>'+
      '<p><strong>Formulaire type de rétractation</strong><br>« À l\'attention de '+TODO+' : je vous notifie par la présente ma rétractation du contrat portant sur la vente du bien ci-dessous. Commandé le … / reçu le … . Nom du consommateur … . Adresse du consommateur … . Date … . »</p>'+
      '<p><strong>Au-delà du délai légal</strong>, nous accordons commercialement <strong>trente jours</strong> pour un retour, portée ou non. Cet engagement s\'ajoute à vos droits, il ne les remplace pas.</p>'+
      '<h2>Article 6 — Garanties légales</h2>'+
      '<p>Tous nos produits bénéficient de la <strong>garantie légale de conformité</strong> (articles L217-3 et suivants du Code de la consommation), d\'une durée de deux ans à compter de la délivrance, et de la <strong>garantie contre les vices cachés</strong> (articles 1641 et suivants du Code civil). Ces garanties s\'appliquent indépendamment de toute garantie commerciale.</p>'+
      '<h2>Article 7 — Nature du produit</h2><p>La Stabyl S2 est un accessoire de maintien et de confort. Elle n\'est pas un dispositif médical au sens du règlement (UE) 2017/745, ne revendique aucune finalité thérapeutique et ne se substitue pas à l\'avis d\'un professionnel de santé.</p>'+
      '<h2>Article 8 — Données personnelles</h2><p>Le traitement de vos données est décrit dans notre <a href="#/confidentialite">politique de confidentialité</a>.</p>'+
      '<h2>Article 9 — Règlement des litiges</h2><p>En cas de litige, vous pouvez recourir gratuitement au médiateur de la consommation dont les coordonnées figurent dans nos <a href="#/mentions">mentions légales</a>, ou à la plateforme européenne de règlement en ligne des litiges. Le droit français est applicable.</p>');
  };

  views["#/confidentialite"] = function(){
    return doc("Politique de confidentialité","Quelles données nous collectons, pourquoi, combien de temps, et comment les faire supprimer.",
      '<h2>Responsable du traitement</h2><p>'+TODO+', dont les coordonnées figurent dans les <a href="#/mentions">mentions légales</a>.</p>'+
      '<h2>Données collectées</h2><ul>'+
      '<li><strong>Commande</strong> : nom, prénom, adresse postale, e-mail, téléphone. Base légale : exécution du contrat.</li>'+
      '<li><strong>Navigation</strong> : pages consultées, appareil, données de mesure d\'audience. Base légale : votre consentement, recueilli via le bandeau cookies.</li>'+
      '<li><strong>Support</strong> : contenu de vos échanges avec nous. Base légale : intérêt légitime à répondre.</li></ul>'+
      '<p>Aucune donnée de carte bancaire ne transite par nos serveurs : le paiement est traité par notre prestataire.</p>'+
      '<h2>Destinataires</h2><p>Vos données sont transmises aux seuls sous-traitants nécessaires : hébergement et boutique (Shopify), transporteur, prestataire de paiement, et outil de mesure publicitaire lorsque vous y avez consenti.</p>'+
      '<h2>Durée de conservation</h2><ul><li>Données de commande : durée légale de conservation comptable, soit dix ans.</li><li>Données de prospection : trois ans à compter du dernier contact.</li><li>Traceurs de mesure : treize mois au maximum.</li></ul>'+
      '<h2>Vos droits</h2><p>Vous disposez d\'un droit d\'accès, de rectification, d\'effacement, de limitation, d\'opposition et de portabilité. Écrivez à '+TODO+' — nous répondons sous un mois. Vous pouvez également saisir la CNIL.</p>');
  };

  views["#/cookies"] = function(){
    return doc("Politique de cookies","Ce que nous déposons, et comment refuser aussi simplement qu'accepter.",
      '<h2>Le principe</h2><p>Aucun traceur publicitaire ou de mesure d\'audience n\'est déposé avant votre consentement. Refuser doit être aussi simple qu\'accepter : le bandeau propose les deux actions au même niveau, et poursuivre la navigation ne vaut pas acceptation.</p>'+
      '<h2>Les catégories</h2><ul>'+
      '<li><strong>Strictement nécessaires</strong> — panier, session, sécurité. Ils ne peuvent pas être désactivés et ne requièrent pas de consentement.</li>'+
      '<li><strong>Mesure d\'audience</strong> — comprendre quelles pages sont consultées. Déposés uniquement après consentement.</li>'+
      '<li><strong>Publicité</strong> — mesurer l\'efficacité de nos campagnes. Déposés uniquement après consentement.</li></ul>'+
      '<h2>Retirer son consentement</h2><p>Vous pouvez modifier votre choix à tout moment depuis le lien de gestion des cookies présent en pied de page, ou en supprimant les cookies dans les réglages de votre navigateur. Le consentement est redemandé au bout de treize mois.</p>');
  };

  views["#/retours"] = function(){
    return doc("Retours et remboursement","La procédure complète, en quatre étapes.",
      '<h2>Le délai</h2><p>Vous avez <strong>trente jours à compter de la réception</strong> pour nous renvoyer la sangle, portée ou non, lavée ou non. C\'est un engagement commercial plus large que les quatorze jours de rétractation prévus par la loi, qui restent acquis en tout état de cause.</p>'+
      '<h2>La procédure</h2><ul>'+
      '<li>Écrivez à '+TODO+' en indiquant votre référence de commande.</li>'+
      '<li>Nous vous envoyons une étiquette de retour prépayée sous un jour ouvré.</li>'+
      '<li>Déposez le colis dans un point relais ou un bureau de poste.</li>'+
      '<li>Le remboursement est déclenché à réception, sur le moyen de paiement d\'origine, sous quatorze jours au maximum.</li></ul>'+
      '<h2>Les frais</h2><p>Le retour est à notre charge : l\'étiquette est fournie. Vous ne réglez rien.</p>'+
      '<h2>Produit défectueux</h2><p>Si la sangle présente un défaut, la garantie légale de conformité s\'applique pendant deux ans. Envoyez-nous une photo : nous procédons au remplacement ou au remboursement sans vous demander de renvoyer le produit dans la plupart des cas.</p>');
  };

  views["#/contact"] = function(){
    return doc("Nous écrire","Une vraie personne lit, et répond sous un jour ouvré.",
      '<h2>Par e-mail</h2><p>'+TODO+' — c\'est le canal le plus rapide. Indiquez votre référence de commande si vous en avez une.</p>'+
      '<h2>Par courrier</h2><p>'+TODO+' — adresse postale du siège.</p>'+
      '<h2>Nos délais</h2><ul><li>Réponse aux e-mails : un jour ouvré.</li><li>Envoi d\'une étiquette de retour : un jour ouvré.</li><li>Remboursement après réception d\'un retour : quatorze jours au maximum, généralement trois.</li></ul>'+
      '<h2>Avant d\'écrire</h2><p>Le <a href="#/tailles">guide des tailles</a> et les <a href="#/faq">questions fréquentes</a> répondent à l\'essentiel des demandes, en particulier sur la mesure et la discrétion sous le vêtement.</p>');
  };


  /* ---------- scène 3D : jambe, rotule, sangle ---------- */
  var V3 = {raf:null, renderer:null, onResize:null};
  function destroy3D(){
    if(V3.raf) cancelAnimationFrame(V3.raf);
    if(V3.onResize) window.removeEventListener("resize", V3.onResize);
    if(V3.renderer){ try{ V3.renderer.dispose(); }catch(e){} }
    V3 = {raf:null, renderer:null, onResize:null};
  }
  function init3D(){
    var el = document.getElementById("stage3d");
    if(!el || !window.THREE) return;
    var w = el.clientWidth, h = el.clientHeight;
    if(!w || !h) return;

    var renderer = new THREE.WebGLRenderer({antialias:true, alpha:true});
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.setSize(w, h);
    renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.0;
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    el.appendChild(renderer.domElement);
    el.classList.add("live");

    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(30, w/h, 0.1, 100);
    camera.position.set(0, -0.15, 8.4);
    camera.lookAt(0, -0.42, 0);

    /* éclairage de studio doux */
    scene.add(new THREE.HemisphereLight(0xfff6ee, 0x7a6e62, 0.48));
    var key = new THREE.DirectionalLight(0xffffff, 1.05);
    key.position.set(3.2, 3.8, 4.6); key.castShadow = true;
    key.shadow.mapSize.set(2048, 2048);
    key.shadow.camera.left = -2.5; key.shadow.camera.right = 2.5;
    key.shadow.camera.top = 2.5;   key.shadow.camera.bottom = -3.5;
    key.shadow.camera.near = 1;    key.shadow.camera.far = 16;
    key.shadow.bias = -0.0004; key.shadow.normalBias = 0.025; key.shadow.radius = 4;
    scene.add(key);
    var fill = new THREE.DirectionalLight(0xffe9d8, 0.35); fill.position.set(-4, 0.5, 2.5); scene.add(fill);
    var rim  = new THREE.DirectionalLight(0xffffff, 0.65); rim.position.set(-2.5, 2, -4); scene.add(rim);

    /* ---------- anatomie : un seul maillage continu, déformé point par point ----------
       angle t : 0 = avant, +PI/2 = côté externe, PI = arrière ; genou à y = 0 */
    var PROF = [[2.8,0.74],[1.8,0.70],[1.2,0.64],[0.7,0.575],[0.35,0.525],[0.05,0.505],
                [-0.3,0.475],[-0.7,0.49],[-1.1,0.50],[-1.6,0.445],[-2.2,0.345],[-3.4,0.27]];
    function baseR(y){
      var P = PROF, i = 0;
      if(y >= P[0][0]) return P[0][1];
      if(y <= P[P.length-1][0]) return P[P.length-1][1];
      while(i < P.length-2 && y < P[i+1][0]) i++;
      var p0 = P[Math.max(0,i-1)][1], p1 = P[i][1], p2 = P[i+1][1], p3 = P[Math.min(P.length-1,i+2)][1];
      var t = (P[i][0] - y) / (P[i][0] - P[i+1][0]), t2 = t*t, t3 = t2*t;
      return 0.5*((2*p1) + (-p0+p2)*t + (2*p0-5*p1+4*p2-p3)*t2 + (-p0+3*p1-3*p2+p3)*t3);
    }
    function sstep(a, b, v){ var q = Math.min(1, Math.max(0, (v-a)/(b-a))); return q*q*(3-2*q); }
    function gauss(v, m, sd){ var d = (v-m)/sd; return Math.exp(-0.5*d*d); }
    function ang(t, c){ return Math.atan2(Math.sin(t-c), Math.cos(t-c)); }
    function lobe(t, c, wd){ var d = ang(t,c)/wd; return Math.exp(-0.5*d*d); }
    var PI = Math.PI;
    var BUMPS = [
      [ 0.085,  0.10, 0.17,  0.00, 0.42],   /* rotule */
      [ 0.030,  0.42, 0.14,  0.00, 0.35],   /* tendon du quadriceps */
      [ 0.060,  0.55, 0.22, -0.75, 0.45],   /* vaste médial */
      [ 0.030,  0.90, 0.35,  0.95, 0.50],   /* vaste latéral */
      [ 0.024, -0.25, 0.14,  0.00, 0.18],   /* tendon rotulien */
      [-0.030, -0.12, 0.12,  0.55, 0.20],   /* creux de part et d'autre du tendon */
      [-0.030, -0.12, 0.12, -0.55, 0.20],
      [ 0.030, -0.45, 0.10,  0.00, 0.25],   /* tubérosité tibiale */
      [-0.070,  0.02, 0.22,  PI,   0.55],   /* creux poplité */
      [ 0.040,  0.30, 0.25,  PI-0.62, 0.22],/* tendons ischio-jambiers */
      [ 0.040,  0.30, 0.25,  PI+0.62, 0.22],
      [ 0.130, -1.00, 0.42,  PI+0.45, 0.55],/* mollet, chef médial */
      [ 0.100, -0.92, 0.38,  PI-0.45, 0.50],/* mollet, chef latéral */
      [ 0.018, -1.30, 0.70,  0.00, 0.12],   /* crête du tibia */
      [ 0.040, -0.02, 0.20, -1.45, 0.45],   /* condyle médial */
      [ 0.025,  0.00, 0.20,  1.45, 0.40]    /* condyle latéral */
    ];
    function legR(y, t){
      var sx = 1.0 + 0.10*gauss(y, 0, 0.35) - 0.05*sstep(-0.4, -1.2, y);
      var sz = 0.96 - 0.06*gauss(y, 0, 0.35) + 0.06*sstep(-0.4, -1.2, y);
      var st = Math.sin(t), ct = Math.cos(t);
      var r = baseR(y) / Math.sqrt((st*st)/(sx*sx) + (ct*ct)/(sz*sz));
      for(var i = 0; i < BUMPS.length; i++){
        var b = BUMPS[i];
        r += b[0] * gauss(y, b[1], b[2]) * lobe(t, b[3], b[4]);
      }
      return r;
    }
    /* légère flexion : la cuisse et la jambe partent en arrière, le genou avance */
    function bendA(y){ return y > 0 ? -0.10*Math.min(1, y/0.9) : 0.08*Math.min(1, -y/0.9); }
    function place(r, y, t, out){
      var x = r*Math.sin(t), z = r*Math.cos(t), a = bendA(y);
      out.set(x, y*Math.cos(a) - z*Math.sin(a), y*Math.sin(a) + z*Math.cos(a));
      return out;
    }

    var v = new THREE.Vector3();
    var NS = 112, NY = 190, Y0 = 2.8, Y1 = -3.4;
    var pos = new Float32Array(NS*NY*3), idx = [];
    for(var jy = 0; jy < NY; jy++){
      var yy = Y0 + (Y1 - Y0)*(jy/(NY-1));
      for(var k = 0; k < NS; k++){
        var tt = (k/NS)*PI*2 - PI;
        place(legR(yy, tt), yy, tt, v);
        var o = (jy*NS + k)*3; pos[o] = v.x; pos[o+1] = v.y; pos[o+2] = v.z;
      }
    }
    for(var jy = 0; jy < NY-1; jy++){
      for(var k = 0; k < NS; k++){
        var a0 = jy*NS + k, a1 = jy*NS + (k+1)%NS, b0 = (jy+1)*NS + k, b1 = (jy+1)*NS + (k+1)%NS;
        idx.push(a0, b0, a1,  a1, b0, b1);
      }
    }
    var legGeo = new THREE.BufferGeometry();
    legGeo.setAttribute("position", new THREE.BufferAttribute(pos, 3));
    legGeo.setIndex(idx);
    legGeo.computeVertexNormals();
    var skin = new THREE.MeshStandardMaterial({color:0xC28B66, roughness:0.6, metalness:0});

    var g = new THREE.Group();
    var leg = new THREE.Mesh(legGeo, skin);
    leg.castShadow = true; leg.receiveShadow = true; g.add(leg);

    /* ---------- la sangle : calculée sur la surface de la jambe ---------- */
    var SY = -0.74, HB = 0.30, TH = 2.1;
    var dotCanvas = document.createElement("canvas"); dotCanvas.width = 2048; dotCanvas.height = 256;
    var dotTex = new THREE.CanvasTexture(dotCanvas);
    dotTex.encoding = THREE.sRGBEncoding; dotTex.anisotropy = 8;
    function paintDots(hex){
      var x = dotCanvas.getContext("2d"), W = 2048, H = 256;
      x.fillStyle = "#1C1C20"; x.fillRect(0, 0, W, H);
      x.globalAlpha = 0.06; x.fillStyle = "#ffffff";
      for(var ly = 0; ly < H; ly += 4){ x.fillRect(0, ly, W, 1); }
      x.globalAlpha = 1;
      x.fillStyle = "#0D0D0F"; x.fillRect(0, 0, W, 16); x.fillRect(0, H-16, W, 16);
      var u0 = W*(0.5 - TH/(4*PI)), u1 = W*(0.5 + TH/(4*PI)), uc = (u0+u1)/2, half = (u1-u0)/2;
      x.fillStyle = hex;
      for(var r = 0; r < 8; r++){
        var py = 36 + r*26.5;
        for(var px = u0 + 14 + (r%2 ? 11 : 0); px < u1 - 10; px += 22){
          var d = Math.abs(px - uc)/half, rad = 6.4*(1 - d*0.82);
          if(rad < 1.4) continue;
          x.beginPath(); x.arc(px, py, rad, 0, PI*2); x.fill();
        }
      }
      dotTex.needsUpdate = true;
    }
    paintDots(COLS[PICK[0]].hex);

    var SN = 160, SR = 22;
    var spos = new Float32Array((SN+1)*SR*3), suv = new Float32Array((SN+1)*SR*2), sidx = [];
    for(var jr = 0; jr < SR; jr++){
      var vv = jr/(SR-1), yb = SY - HB + 2*HB*vv, vc = 2*vv - 1;
      var edge = Math.sqrt(Math.max(0, 1 - Math.pow(Math.abs(vc), 6)));
      for(var ks = 0; ks <= SN; ks++){
        var ts = (ks/SN)*PI*2 - PI;
        var padW = Math.exp(-0.5*Math.pow(ang(ts,0)/(TH*0.42), 6));
        var thick = 0.006 + (0.030 + 0.045*padW) * edge;
        place(legR(yb, ts) + thick, yb, ts, v);
        var q = jr*(SN+1) + ks;
        spos[q*3] = v.x; spos[q*3+1] = v.y; spos[q*3+2] = v.z;
        suv[q*2] = ks/SN; suv[q*2+1] = vv;
      }
    }
    for(var jr = 0; jr < SR-1; jr++){
      for(var ks = 0; ks < SN; ks++){
        var c0 = jr*(SN+1)+ks, c1 = c0+1, e0 = (jr+1)*(SN+1)+ks, e1 = e0+1;
        sidx.push(c0, c1, e0,  c1, e1, e0);
      }
    }
    var sGeo = new THREE.BufferGeometry();
    sGeo.setAttribute("position", new THREE.BufferAttribute(spos, 3));
    sGeo.setAttribute("uv", new THREE.BufferAttribute(suv, 2));
    sGeo.setIndex(sidx);
    sGeo.computeVertexNormals();
    var nrm = sGeo.attributes.normal;
    for(var jr = 0; jr < SR; jr++){
      var i0 = jr*(SN+1), i1 = i0 + SN;
      var nx = nrm.getX(i0)+nrm.getX(i1), ny = nrm.getY(i0)+nrm.getY(i1), nz = nrm.getZ(i0)+nrm.getZ(i1);
      var L = Math.sqrt(nx*nx + ny*ny + nz*nz) || 1;
      nrm.setXYZ(i0, nx/L, ny/L, nz/L); nrm.setXYZ(i1, nx/L, ny/L, nz/L);
    }
    var strap = new THREE.Mesh(sGeo, new THREE.MeshStandardMaterial({map:dotTex, roughness:0.8, metalness:0.02}));
    strap.castShadow = true; strap.receiveShadow = true; g.add(strap);

    /* passant métallique + patte velcro sur le côté externe */
    var sideT = PI/2, sideR = legR(SY, sideT);
    var dark  = new THREE.MeshStandardMaterial({color:0x1C1C20, roughness:0.85});
    var velc  = new THREE.MeshStandardMaterial({color:0x34343A, roughness:0.95});
    var metal = new THREE.MeshStandardMaterial({color:0xA3A9B1, roughness:0.32, metalness:0.85});
    var tabG = new THREE.Group();
    var tab = new THREE.Mesh(new THREE.BoxGeometry(0.05, 0.36, 0.44), dark);
    tab.position.set(0, 0, -0.22); tab.castShadow = true; tabG.add(tab);
    var vel = new THREE.Mesh(new THREE.BoxGeometry(0.054, 0.26, 0.24), velc);
    vel.position.set(0.004, 0, -0.30); tabG.add(vel);
    var ring = new THREE.Mesh(new THREE.TorusGeometry(0.17, 0.02, 12, 32), metal);
    ring.rotation.y = PI/2; ring.castShadow = true; tabG.add(ring);
    place(sideR + 0.08, SY, sideT, v);
    tabG.position.copy(v); tabG.rotation.set(bendA(SY), -0.25, 0); g.add(tabG);

    g.rotation.x = 0.04;
    scene.add(g);

    /* étiquettes ancrées sur l'anatomie */
    var layer = document.createElement("div");
    layer.className = "lab3d-layer";
    el.appendChild(layer);
    function anchor(pt, txt){
      var ob = new THREE.Object3D(); ob.position.copy(pt); g.add(ob);
      var sp = document.createElement("span"); sp.className = "lab3d big"; sp.textContent = txt;
      layer.appendChild(sp);
      return {o:ob, el:sp};
    }
    var anchors = [
      anchor(place(legR(0.12, 0) + 0.22, 0.12, 0, new THREE.Vector3()), "Votre genou"),
      anchor(place(legR(SY - 0.62, 0) + 0.25, SY - 0.62, 0, new THREE.Vector3()), "La sangle se place ici"),
      anchor(place(sideR + 0.55, SY, sideT, new THREE.Vector3()), "On serre ici")
    ];
    var wp = new THREE.Vector3();

    var targetY = -0.30, curY = -0.30, dragging = false, lastX = 0, auto = true;
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var cv = renderer.domElement;
    cv.addEventListener("pointerdown", function(e){ dragging = true; auto = false; lastX = e.clientX; cv.setPointerCapture(e.pointerId); });
    cv.addEventListener("pointermove", function(e){ if(!dragging) return; targetY += (e.clientX - lastX) * 0.009; lastX = e.clientX; });
    cv.addEventListener("pointerup", function(){ dragging = false; });
    cv.addEventListener("pointercancel", function(){ dragging = false; });

    V3.renderer = renderer;
    V3.setColor = function(c){ if(COLS[c]) paintDots(COLS[c].hex); if(!auto){ targetY = -0.25; } };
    V3.onResize = function(){
      var W = el.clientWidth, H = el.clientHeight;
      if(!W || !H) return;
      camera.aspect = W/H; camera.updateProjectionMatrix(); renderer.setSize(W, H);
    };
    window.addEventListener("resize", V3.onResize);

    (function loop(){
      V3.raf = requestAnimationFrame(loop);
      if(auto && !reduce){ V3.t = (V3.t || 0) + 0.012; targetY = -0.25 + Math.sin(V3.t) * 0.85; }
      curY += (targetY - curY) * 0.085;
      g.rotation.y = curY;
      renderer.render(scene, camera);

      var W = el.clientWidth, H = el.clientHeight;
      for(var ia = 0; ia < anchors.length; ia++){
        var an = anchors[ia];
        an.o.getWorldPosition(wp);
        var depth = wp.z;
        wp.project(camera);
        var lx = (wp.x * 0.5 + 0.5) * W, lyy = (-wp.y * 0.5 + 0.5) * H;
        an.el.style.left = Math.max(88, Math.min(W - 88, lx)) + "px";
        an.el.style.top  = Math.max(24, Math.min(H - 24, lyy)) + "px";
        an.el.style.opacity = depth > 0.25 ? "1" : (depth > -0.25 ? "0.18" : "0");
      }
    })();
  }

  /* ---------- routeur ---------- */
  function route(){
    destroy3D();
    var h = location.hash || "#/";
    var base = h.split("?")[0];
    var view = views[base] || views["#/"];
    app.innerHTML = view();
    Array.prototype.forEach.call(document.querySelectorAll("[data-nav]"), function(a){
      a.classList.toggle("on", a.getAttribute("data-nav") === base);
    });
    paintCount();
    window.scrollTo(0,0);
    syncSticky();
    if(base === "#/") init3D();
    var rf = document.getElementById("reviewform");
    if(rf) rf.addEventListener("submit", submitReview);
    var of = document.getElementById("orderform");
    if(of) of.addEventListener("submit", submitOrder);
    var tf = document.getElementById("trackform");
    if(tf) tf.addEventListener("submit", function(e){
      e.preventDefault();
      document.getElementById("trackmsg").textContent =
        "Aucune commande ne correspond à cette référence dans ce navigateur. Sur la boutique réelle, la recherche interrogera votre compte Shopify.";
    });
  }

  function submitOrder(e){
    e.preventDefault();
    var need = ["f-mail","f-prenom","f-nom","f-adr","f-cp","f-ville"], ok = true;
    need.forEach(function(id){
      var el = document.getElementById(id);
      if(el && !el.value.trim()){ el.style.borderColor = "#B4342B"; ok = false; }
      else if(el){ el.style.borderColor = ""; }
    });
    if(!ok){ return; }
    var L = items();
    var ref = "STB-" + new Date().toISOString().slice(0,10).replace(/-/g,"") + "-" + String(Math.floor(1000+Math.random()*9000));
    writeLS(ORDER_KEY, {
      ref: ref,
      date: new Date().toISOString(),
      lignes: L.map(function(it){ return {nom:it.lot.nom+" ("+colNames(it.cols)+")", q:it.q, montant:it.lot.prix*it.q}; }),
      total: total()
    });
    cart = {}; saveCart();
    location.hash = "#/confirmation";
  }

  /* sélection de quantité + barre d'achat flottante */
  var sticky = document.getElementById("sticky"), sbLabel = document.getElementById("sb-label");
  function syncSticky(){
    var onProduct = (location.hash||"#/") === "#/";
    var box = document.getElementById("buybox");
    var passed = box ? (box.getBoundingClientRect().bottom < 0) : false;
    sticky.classList.toggle("on", onProduct && passed);
    sbLabel.textContent = selLabel();
  }
  function paintSel(){
    Array.prototype.forEach.call(document.querySelectorAll("[data-opt]"), function(b){
      b.setAttribute("aria-checked", String(b.getAttribute("data-opt") === SEL));
    });
    var b = document.getElementById("addsel");
    if(b) b.textContent = "Ajouter au panier — " + eur(LOTS[SEL].prix);
    var cb = document.getElementById("colorbox"); if(cb) cb.innerHTML = colorInner();
    sbLabel.textContent = selLabel();
  }
  function addSelected(button){
    var key = SEL + "|" + PICK.slice(0, LOTS[SEL].n).join(",");
    var msg = document.getElementById("cartmsg"); if(msg) msg.textContent = "";
    setBusy(button, true);
    addPackToShopify(key).then(function(){
      location.hash = "#/panier";
    }).catch(cartError).then(function(){ setBusy(button, false); });
  }
  window.addEventListener("scroll", syncSticky, {passive:true});
  document.getElementById("sb-add").addEventListener("click", function(e){ addSelected(e.currentTarget); });

  document.addEventListener("click", function(e){
    var opt = e.target.closest("[data-opt]");
    if(opt){ SEL = opt.getAttribute("data-opt"); paintSel(); return; }
    if(e.target.closest("#addsel")){ addSelected(e.target.closest("#addsel")); return; }
    if(e.target.closest("#rv-demo")){
      RV_DEMO = !RV_DEMO; route();
      var sa = document.getElementById("avis"); if(sa) sa.scrollIntoView({block:"start"});
      return;
    }
    var sw = e.target.closest("[data-col]");
    if(sw){
      var u = +sw.getAttribute("data-unit"), c = sw.getAttribute("data-col");
      if(COLS[c] && u >= 0 && u < 3){
        PICK[u] = c;
        var cbx = document.getElementById("colorbox"); if(cbx) cbx.innerHTML = colorInner();
        if(V3.setColor) V3.setColor(c);
        var again = document.querySelector('[data-col="'+c+'"][data-unit="'+u+'"]'); if(again) again.focus();
      }
      return;
    }
    var t = e.target.closest("[data-add],[data-inc],[data-dec],[data-rm]");
    if(!t) return;
    var id;
    if((id = t.getAttribute("data-add"))){
      setBusy(t, true);
      addPackToShopify(id).then(function(){
        if((location.hash||"#/") === "#/panier") route(); else location.hash = "#/panier";
      }).catch(cartError).then(function(){ setBusy(t, false); });
    } else if((id = t.getAttribute("data-inc"))){
      setBusy(t, true, "…");
      addPackToShopify(id).then(route).catch(cartError).then(function(){ setBusy(t, false); });
    } else if((id = t.getAttribute("data-dec"))){
      setBusy(t, true, "…");
      removePackFromShopify(id, false).then(route).catch(cartError).then(function(){ setBusy(t, false); });
    } else if((id = t.getAttribute("data-rm"))){
      setBusy(t, true, "Suppression…");
      removePackFromShopify(id, true).then(route).catch(cartError).then(function(){ setBusy(t, false); });
    }
  });

  window.addEventListener("hashchange", route);
  route();
})();
